/**
 * WebSocket constants without zod, so browser code (the storefront, through
 * `@luckymenu/core/client`) and `packages/realtime-client` can use them.
 * realtime.ts re-exports them. See docs/architecture/realtime-notifications.md.
 */

export const WS_PATH = "/api/ws";

/**
 * Close codes. Clients reconnect after all of them except `forbidden` and
 * `notFound`, which need a different sign-in or restaurant first.
 */
export const WS_CLOSE = {
	/** The server is restarting: reconnect soon. Standard code 1012. */
	restart: 1012,
	/** No auth in time, a bad or expired token, or no guest session. Refresh and reconnect. */
	unauthenticated: 4001,
	/** Membership disabled or support session ended. */
	forbidden: 4003,
	/** No such restaurant, or not a member. */
	notFound: 4004,
	/** Too many sockets for this user or guest session. Reconnect slowly. */
	tooManySockets: 4008,
	/** Missed two pings. */
	heartbeat: 4009,
	/** A message that is not JSON or not in the protocol. */
	badMessage: 4010,
} as const;
